import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@11/swiper.min.mjs'
import EffectFade from 'https://cdn.jsdelivr.net/npm/swiper@11/modules/effect-fade.min.mjs';
import Autoplay from 'https://cdn.jsdelivr.net/npm/swiper@11/modules/autoplay.min.mjs';

export default () => {
    const reviewsFade = new Swiper(".m-reviews-fade", {
        modules: [EffectFade, Autoplay],
        speed: 350,
        autoplay: {
            delay: 5500,
        },
        fadeEffect: {
            crossFade: true
        },
        effect: "fade",
    });
}
